<template>
  <div class="gc-info-wrap">
    <van-nav-bar :border="false"
                 title="个人信息"
                 left-arrow
                 @click-left="$router.back()"
    />
    <div class="page-info-wrap">
      <div class="item">
        <span>头像</span>
        <div class="img-wrap">
          <img :src="info.Item.HeadImgUrl" alt="">
          <!-- <van-uploader :after-read="afterRead"/> -->
        </div>
      </div>
      <div class="item">
        <span>性别</span>
        {{ info.UserSex }}
      </div>
      <div class="item">
        <span>工号</span>
        {{ info.Item.Sysno }}
      </div>
      <div class="item">
        <span>身份证号</span>
        <input class="input" v-model="info.UserCode" disabled type="text">
      </div>
      <div class="item">
        <span>学历</span>
        {{ info.Education.Name }}
      </div>
      <div class="item">
        <span>现住址</span>
        <input class="input" v-model="info.UserAdress" disabled type="text">
      </div>
      <div class="item">
        <span>联系方式</span>
        <input class="input" v-model="info.AdressItem.UserTel" disabled type="text">
      </div>
    </div>
    <van-popup v-model="showSex" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsSex"
        @confirm="onConfirmSex"
        @cancel="showSex=false"
      />
    </van-popup>
    <van-popup v-model="showEdu" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsEdu"
        @confirm="onConfirmEdu"
        @cancel="showEdu=false"
      />
    </van-popup>
    <!-- <div class="submit-btn">保  存</div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: {
        Item: {
          HeadImgUrl: ''
        },
        Education: {
          name: ''
        },
        AdressItem: {
          UserTel: ''
        }
      },
      columnsSex: ['男', '女'],
      columnsEdu: ['专科', '本科', '硕士', '博士'],
      showSex: false,
      showEdu: false,
      src: ''
      // fileimg: []
    }
  },
  mounted() {
    this.WebGetItemDetail();
  },
  methods: {
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      this.info.Item.HeadImgUrl = file.content
    },
    onConfirmSex(e) {
      this.info.UserSex = e
      this.showSex = false
    },
    onConfirmEdu(e) {
      this.info.Education.Name = e
      this.showEdu = false
    },
    WebGetGovUserLst() {
      let data = {
        UserSysno: localStorage.getItem('UserSysno')
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetGovUserLst', data, res => {
        console.log(res);
        res = res.WebGetGovUserLstResult
        if (res.ResponseCode == 1) {
          this.info = res.Item

        }
      }, err => {
      })
    },
    // 个人信息详情
    WebGetItemDetail() {
      let data = {
        UserSysno: localStorage.getItem('UserSysno')
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetItemDetail', data, res => {
        console.log(res);
        res = res.WebGetItemDetailResult
        if (res.ResponseCode == 1) {
          this.info = res.Item

        }
      }, err => {
      })
    },
    // 个人信息修改
    aa() {
      let data = {
        UserSysno: localStorage.getItem('UserSysno')
      }
      this.$baseajax.sliceRequest(this.$base.baseapi + '/aa', data, res => {
        console.log(res);
        if (res.ResponseCode == 1) {


        }
      }, err => {
      })
    }

  },
  beforeCreate() {
    document.querySelector('body').className = 'fff'
  },
  destroyed() {
    document.querySelector('body').className = ''
  },
}
</script>

<style lang="less" scoped>
.gc-info-wrap {
  padding-bottom: 1.6rem;
}

.page-info-wrap {
  padding: 0.28rem;

  .item {
    padding: .5rem 0;
    border-bottom: 1px solid #eee;
    font-size: 0.37rem;
    color: #666666;
    display: flex;
    justify-content: space-between;
    align-items: center;

    /deep/ .van-uploader {
      // background: #eee;
      border-radius: 100%;
      opacity: 0;
      margin: 0;
      position: absolute;
      top: 0;
      left: 0;
    }

    /deep/ .van-uploader__upload {
      width: 1.47rem;
      height: 1.47rem;
      margin: 0;
    }

    .img-wrap {
      position: relative;
      background: #eee;
      border-radius: 100%;
      overflow: hidden;

      img {
        display: block;
        width: 1.47rem;
        height: 1.47rem;
      }
    }

    span {
      color: #333333;
    }

    .input {
      text-align: right;
      font-size: 0.37rem;
      color: #666666;
      width: 60%;
    }

    &.arr {
      position: relative;
      padding-right: 0.3rem;

      &:after {
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -0.1rem;
        content: '';
        width: 0.2rem;
        height: 0.2rem;
        border-top: 1px solid #999999;
        border-left: 1px solid #999999;
        transform: rotate(135deg);
      }
    }
  }
}

.submit-btn {
  position: fixed;
  bottom: 0.3rem;
  left: 0.6rem;
  width: 8.8rem;
  height: 1.04rem;
  line-height: 1.04rem;
  background-color: #B71C1C;
  box-shadow: 0rem 1px 0.09rem 0rem rgba(26, 26, 26, 0.29);
  border-radius: 0.2rem;
  text-align: center;
  font-size: 0.47rem;
  color: #ffffff;
}

/deep/ .van-overlay {
  background-color: rgba(0, 0, 0, .5);
}
</style>



// WEBPACK FOOTER //
// src/views/my/Info.vue